export const SUPPORT_ID_COLUMN_NAME = 'ID';
